export interface SubscriptionMixItem {
  grade: string
  memo: string
  count: number
  percentage: number
}

export const subscriptionMix: SubscriptionMixItem[] = [
  { grade: '드러머', memo: '드럼 악보 전체 이용', count: 3120, percentage: 49 },
  { grade: '인지', memo: '인지 리포트 이용', count: 1780, percentage: 28 },
  { grade: '플러스', memo: '드럼+인지 통합 이용', count: 1492, percentage: 23 },
]

export interface RankingItem {
  title: string
  subtitle: string
  plays: number
  badgeLabel: string
  badgeType: 'primary' | 'success'
}

export const rankingItems: RankingItem[] = [
  { title: '찔레꽃', subtitle: '백난아', plays: 2841, badgeLabel: '트로트', badgeType: 'primary' },
  { title: '아리랑', subtitle: '민요', plays: 2390, badgeLabel: '가요', badgeType: 'primary' },
  { title: '고향의 봄', subtitle: '동요', plays: 1944, badgeLabel: '동요', badgeType: 'primary' },
  { title: '기억 카드 맞추기', subtitle: '기억력', plays: 1842, badgeLabel: '인지', badgeType: 'success' },
  { title: '순서 기억 훈련', subtitle: '집중력', plays: 1290, badgeLabel: '인지', badgeType: 'success' },
]

export interface ContentCounts {
  total: number
  public: number
  private: number
  free: number
}

export const scoreContentStatus: ContentCounts & { categories: { name: string; count: number }[] } = {
  total: 4,
  public: 3,
  private: 1,
  free: 2,
  categories: [
    { name: '트로트', count: 1 },
    { name: '가요', count: 1 },
    { name: '동요', count: 1 },
    { name: '팝', count: 1 },
  ],
}

export const cognitiveContentStatus: ContentCounts = {
  total: 3,
  public: 3,
  private: 0,
  free: 3,
}

export const dashboardSpecification = {
  title: '대시보드',
  purpose: '운영자가 서비스 전체 흐름을 빠르게 판단하는 시작 화면입니다.',
  functions: [
    '기간별 악보 플레이와 신규 가입 추이를 확인합니다.',
    '구독 등급 구성과 인기 콘텐츠를 비교해 운영 우선순위를 정합니다.',
  ],
  connections: [
    '회원관리에서 가입자와 이용 상태를 확인합니다.',
    '구독관리의 결제·구독 데이터와 악보로그의 플레이 데이터가 요약됩니다.',
  ],
  app: '사용자 앱의 실제 가입, 구독, 악보 플레이 결과를 운영 지표로 집계해 보여줍니다.',
}

export const dashboardDataModelGuide = [
  '집계 기준: period_start, period_end',
  '읽기 모델: 가입 수, 악보 플레이 수, 등급별 활성 구독 수, 곡별 플레이 순위',
  '원본 데이터는 회원, 구독, 악보 플레이 로그이며 대시보드는 직접 수정하지 않습니다.',
]

export const dashboardImplementationGuide = [
  '화면 식별자: dashboard. 좌측 사이드 메뉴는 유지하고 메인 영역만 전환합니다.',
  '필수 데이터: 기간, 가입 수, 악보 플레이 수, 구독 등급 구성, 인기 콘텐츠.',
  '읽기 전용 집계 화면으로, 원본 회원·구독·플레이 로그를 수정하지 않습니다.',
  '기간 선택에 따라 카드와 인기 콘텐츠 순위를 같은 기준으로 다시 집계합니다.',
  '현재 화면은 운영 UI 목업입니다. 실제 개발에서는 API 응답, 저장 성공·실패, 권한 오류, 빈 목록 상태를 별도로 구현해야 합니다.',
]
